import { useRoute, useModal } from '@composables'
import { onBeforeRouteLeave } from 'vue-router'
import { watch, ref } from 'vue'

export default function (updateTab, cb) {
  const { hideModal, isModalOpen, showModal } = useModal()

  const { push } = useRoute()
  const dirty = ref(false)
  const toRoute = ref(null)
  const toTab = ref(null)

  function handleTabUpdate(tabValue) {
    if (dirty.value) {
      showModal()
      toTab.value = tabValue
    } else {
      updateTab(tabValue)
    }
  }

  onBeforeRouteLeave((to) => {
    if (dirty.value) {
      toRoute.value = to
      showModal()
      return false
    } else {
      return true
    }
  })

  watch(dirty, (value) => {
    if (value) {
      onbeforeunload = (e) => e.preventDefault()
    } else {
      onbeforeunload = null
    }
  })

  function confirmDiscardChanges() {
    dirty.value = false
    hideModal()
    if (cb) {
      cb()
    }

    if (toRoute.value) push(toRoute.value)
    if (toTab.value) updateTab(toTab.value)
  }

  return {
    isUnsavedModalOpen: isModalOpen,
    hideUnsavedModal: hideModal,
    confirmDiscardChanges,
    handleTabUpdate,
    dirty,
  }
}
